import React from 'react';

export default class Text extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      changed: false
    };
    this.intervalId = -1;
  }

  componentWillUnmount(){
    if(this.state.changed)
      this.up();
  }

  componentDidUpdate(prevProp, prevState){
    if((prevProp.refs !== this.props.refs)){
      if(this.state.changed)
        this.up();
      this.setState({
        changed: false
      })
    }
    if(prevProp.value !== this.props.value){
      this.setState({
        value: this.props.value,
      })
    }
  }

  handleChange = (e) => {
    const re = /^(\-)?[0-9||.\b]+$/;
    var val = e.target.value;
    if(val=="") val = 0;
    val.toString().replace(",", ".")
    if(re.test(val)) {
      // console.log('value: '+val)
      this.setState({
        value: val,
        changed: true
      }, ()=>{
        clearInterval(this.intervalId);
        this.intervalId = setTimeout(() => { this.up() }, 1000);
      })
      e.preventDefault();
    }
  }

  handleFocus(event) {
    event.target.select();
  }

  onBlur = () => {
    this.up();
  }

  up = () =>{
    if((this.state.changed==true)&&(this.props.callback!=null)){
      this.props.callback({
        field: this.props.name,
        value: this.state.value
      });
      if(this.props.hasOwnProperty('onChange'))
        this.props.onChange();
    }
    this.setState({
      changed: false
    })
    clearInterval(this.intervalId);
  }

  render() {
    return (
        <input
          type="number"
          placeholder={this.props.ph}
          value={this.state.value}
          className="form-control"
          autoComplete="off"
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.up}
        />
    );
  }
}
